
















































































import { Component, Vue } from 'vue-property-decorator';
import { Form, Field, RadioGroup, Radio, Button } from 'vant';
import { regExpObj } from '@/utils/regexp';
import commonApi from '@/api/common';
import jdContractApi from '@/api/jd/contract';
import { encrypt } from '@/utils/common';

interface ReasonData {
  data: Array<any>;
}

@Component({
  name: 'JdCancelContract',
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button
  }
})

export default class JdCancelContract extends Vue {
  formInfo = {
    name: '',
    mobile: '',
    certNo: '',
    cancelReason: '',
    cancelDesc: ''
  };

  reasonList: Array<any> = [];
  applySuccess = false;

  get isDisabled() {
    return !this.formInfo.name || !this.formInfo.mobile || !this.formInfo.certNo ||
      !this.formInfo.cancelReason || !this.formInfo.cancelDesc;
  }

  created() {
    console.log(666);
    this.getCancelReasonList();
  }

  getCancelReasonList() {
    this.$http({
      url: commonApi.qryDictData.url + 'JD_AGREEMENT_CANCEL_REASON',
      method: commonApi.qryDictData.method
    }).then((res: ReasonData) => {
      console.log('解约原因列表', res);
      this.reasonList = res.data;
    });
  }

  // 校验用户名
  validatorName(val: string) {
    return regExpObj.userName.test(val);
  }

  // 校验手机号码
  validatePhone(val: string) {
    return regExpObj.telephone.test(val);
  }

  // 校验身份证后四位
  validateCertNo(val: string) {
    return /\d{3}[0-9xX]/.test(val);
  }

  // 提交解约申请
  onSubmit() {
    this.$http({
      url: jdContractApi.cancelApply.url,
      method: jdContractApi.cancelApply.method,
      params: {
        nameEncrypt: encrypt(this.formInfo.name),
        mobileEncrypt: encrypt(this.formInfo.mobile),
        certNo: this.formInfo.certNo,
        cancelReason: this.formInfo.cancelReason,
        cancelDesc: this.formInfo.cancelDesc
      }
    }).then(() => {
      this.$toast.success('提交成功');
      this.applySuccess = true;
    });
  }
}

